/*
 * @Descripttion:
 * @version:
 * @Author: jianghongtao
 * @Date: 2023-04-14 10:15:49
 */
/**
 * 语言列表，可根据项目需要动态调整
 * @type {{en: string, zh_CN: string}}
 */
export const langList = { zh_CN: '中文', en: 'English' }

/**
 * 基础语言 KEY，可根据项目需要动态调整
 * @type {string}
 */
export const baseLangKey = '_xLang_code'

/**
 * 多语言项目标识 KEY，可根据项目需要动态调整
 * @type {string}
 */
export const projectLanguageKey = 'giga'

/**
 * 本地缓存失效时间，单位：秒
 * @type {string}
 */
export const expireTime = 180
